import { render } from "./nuestros_colaboradores.vue?vue&type=template&id=b4f13374"
import script from "./nuestros_colaboradores.vue?vue&type=script&lang=js"
export * from "./nuestros_colaboradores.vue?vue&type=script&lang=js"

import "./nuestros_colaboradores.vue?vue&type=style&index=0&id=b4f13374&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__